import { Component } from '@angular/core';

@Component({
  selector: 'ongoing-projects',
  templateUrl: './ongoing-projects.component.html',
  styleUrls: ['./ongoing-projects.component.scss']
})
export class OngoingProjectsComponent {
  public getRouterLinkNew() {
    return '/client-project/nieuw/0';
  }
}
